/*  ========================================================================
    # Scripts - Tabs with Gallery
    ========================================================================  */

/**
 * Script that handles interactive functionality of the tabbed section
 */

const TabsWithGallery = {
  cfg: {
    allTabButtons: document.querySelectorAll('.s-tabs-with-gallery__tab-button'),
    getTabButtons: guid =>
      document.querySelectorAll(`.s-tabs-with-gallery__tab-button[data-tabs="${guid}"]`),
    getTabs: guid => document.querySelectorAll(`.s-tabs-with-gallery__tab[data-tabs="${guid}"]`)
  },

  /**
   * Initialize.
   */
  init() {
    this.cfg.allTabButtons.forEach(button => {
      button.addEventListener('click', event => {
        const guid = event.target.getAttribute('data-tabs');
        const index = event.target.getAttribute('data-index');

        // Set current attribute on buttons
        this.cfg
          .getTabButtons(guid)
          .forEach(button =>
            button.toggleAttribute('data-current', index === button.getAttribute('data-index'))
          );

        // Set current attribute on tabs
        this.cfg
          .getTabs(guid)
          .forEach(tab =>
            tab.toggleAttribute('data-current', index === tab.getAttribute('data-index'))
          );
      });
    });
  }
};

export default TabsWithGallery;
